/* istanbul ignore file */
export enum MessageActionEnum {
	CREATE = 'create',
	DELETE = 'delete',
	UPDATE = 'update',
	UPDATE_STATUS = 'update_status'
}
